<template>
	<v-container>
	  <v-row justify="center">
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-1">
	  		<v-card class="elevation-0 transparent">
	  			<v-card-text>
						<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Lecciones 
            </div>
	  			</v-card-text>
	  		</v-card>
	  	</v-col>

	  	<v-col cols="12" sm="7" md="6" lg="5">
		    <v-card class="shadowCard">
			    <v-list flat>
			      <v-list-item-group
			        color="primary"
			      >
			        <v-list-item
			          v-for="(recurso, i) in recursos"
			          :key="i"
			          @click="verRecurso( recurso )"
			        >
			          <v-list-item-icon>
			            <v-icon color="primary"> mdi-file-document-edit </v-icon>
			          </v-list-item-icon>

			          <v-list-item-content>
			            <v-list-item-title v-text="recurso.nombre"></v-list-item-title>
			          </v-list-item-content>
			        </v-list-item>
			      </v-list-item-group>
			    </v-list>
			  </v-card>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          @click="verGrupo( )"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	  <Ejercicio v-if="paramRecurso.estatus" :parametros="paramRecurso"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'
  import Ejercicio  from '@/components/grupos/Ejercicio.vue'

  const  base64 = require('base-64');

	export default {
	  name: "dashboard-default",
	  
	  components: {
	    Alerta,
	    Loader,
	    Ejercicio
	  },
	  
	  data: () => ({
	  	show: false,

    	respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	recursos:[],

     	paramRecurso: {
     		estatus: false,
     		ejercicio: []
     	}
	  }),

	  async created ( ){
    	await this.getRecursos( )
    },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecurso' ])

	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirVentanaRecurso', 'abrirGrupoTeacher'] ),

	  	getRecursos ( ){
    		this.cargar = true
  			// Preparamos el id del teacher
    		const id_grupo = base64.encode( this.getGrupo.grupo.id )
  			// Hacemos la consulta
    		this.$http.get('grupos.recursos/' + id_grupo ).then( response=> {
    			this.recursos = response.body
    		}).catch( error =>{
    			this.validarError( error )
    		}).finally( () => { this.cargar = false })
    	},

    	validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

	  	verRecurso ( recurso ){
	  		this.paramRecurso.ejercicio = recurso.preguntas
	  		this.paramRecurso.estatus   = true
	  	},

	  	verGrupo( ){
        this.cargar = true
    		this.abrirGrupoTeacher( this.getGrupo.grupo ).then(response => { 
          this.cargar = false 
        }).catch( error =>{
          this.validarError ( error )
    		}).finally(()=>{ this.cargar = false })
    	},
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}
</style>
